export class StartEnd {
    constructor(startEndState) {
        this.startEndState = startEndState;
    }
    get id() {
        return this.startEndState.id;
    }
    get status() {
        return this.startEndState.status;
    }
    get dateTimeStart() {
        return this.startEndState.dateTimeStart;
    }
    get dateTimeStop() {
        return this.startEndState.dateTimeStop;
    }
    set status(status) {
        this.status = status;
    }
    getState() {
        return this.startEndState;
    }
}
